import BaseError from "./BaseError";

export default class ConflictError extends BaseError {
  constructor(message: string, info?: any, cause?: Error) {
    super({
      statusCode: 409,
      message,
      info: info || null,
      cause,
    });
    this.name = "ConflictError";
  }
}
